import clsx from 'clsx';
import { ComponentProps } from 'preact';

const LiveBadge = ({ className, ...props }: ComponentProps<'div'>) => (
  <div
    className={clsx('flex items-center justify-center gap-[3px] rounded-[3px] bg-olive-4 px-[5px] py-[2px]', className)}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <div className="size-[5px] rounded-full bg-rose-500" />
    <span className="text-center text-[10px] font-bold leading-4 text-grey-1">LIVE</span>
  </div>
);

export default LiveBadge;
